(function () {
    'use strict';

    angular
        .module('plagiat2017App')
        .controller('InvoicesDataController', InvoicesDataController);

    function InvoicesDataController(InvoicesDataService, ModalService, PlagiatValidationService) {
        var vm = this;
        vm.activeTab = 'invoicesData';

        vm.executeInvoicesData = executeInvoicesData;
        vm.generateInvoicesDataXls = generateInvoicesDataXls;
        vm.columns = ['Name','Region', 'number of docs', 'characters', 'EUROS'];
    
        vm.pending = false;
        vm.obj = {};
        vm.result = null;
        vm.keyCodeEnter = KeyCode.KEY_RETURN;
        
        this.$onInit = function () {
            var dateToChange = new Date();
            dateToChange.setDate(1);
            dateToChange.setDate(dateToChange.getDate() - 1);
            vm.obj.dateTo = dateToChange;

            dateToChange = new Date();
            dateToChange.setMonth(dateToChange.getMonth() - 1);
            dateToChange.setDate(1)
            vm.obj.dateFrom = dateToChange;
        };

        function checkIfParamsValid() {
            if (vm.obj.dateTo && vm.obj.dateFrom && (vm.obj.dateTo < vm.obj.dateFrom)) {
                ModalService.showErrorModal({data: {code: 110}});
                return false;
            }
            return true;
        }
        
        function executeInvoicesData() {
            if (!checkIfParamsValid()) {
                return;
            }
            vm.result = null;
            vm.pending = true;
            InvoicesDataService.executeInvoicesData(vm.obj).then(function (response) {
                vm.result = response.data;
                vm.pending = false;
            }, function (errResponse) {
                vm.pending = false;
                PlagiatValidationService.getModalError(errResponse);
            });
        }
    
        function generateInvoicesDataXls(){
            InvoicesDataService.generateInvoicesDataXls(vm.obj);
        }
    
    }
})();
